export enum LoadingEventType {
  NOT_STARTED = 'not started',
  START = 'start',
  ERROR = 'error',
  PROGRESS = 'progress',
  DONE = 'done'
}
